import { DataAttributeDefinitions } from 'scrivito'

import { pisaJobDataClass } from './Pisa/pisaJobDataClass'

const attributes: DataAttributeDefinitions = {}

export const Job = pisaJobDataClass(attributes)
